import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useIsCurrentProjectJiraSoftware } from '../is-current-project-jira-software/index.tsx';

export const useIsEligibleForInviteOnOpen = () => {
	const { isCurrentProjectJiraSoftware } = useIsCurrentProjectJiraSoftware();
	const isAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();

	return isCurrentProjectJiraSoftware && (isAdmin || isSiteAdmin);
};
